import { render, staticRenderFns } from "./editUserPassword.vue?vue&type=template&id=150e3e89&"
import script from "./editUserPassword.vue?vue&type=script&lang=js&"
export * from "./editUserPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports